import { Tooltip } from '@mui/material';
import { AccountData, VoucherOut, VoucherPaymentStatus, VoucherStatus, VoucherType } from '../api';
import { ReactComponent as ActiveStatusIcon } from '../images/voucherStatusIcons/mb-status-active.svg';
import { ReactComponent as UsedStatusIcon } from '../images/voucherStatusIcons/mb-status-used.svg';
import { ReactComponent as ArchivedStatusIcon } from '../images/voucherStatusIcons/mb-status-archived.svg';
import { ReactComponent as PendingPaymentStatusIcon } from '../images/voucherStatusIcons/mb-status-pending-payment.svg';
import { BalanceStatusIcon } from './BalanceStatusIcon';
import { ReactComponent as OriginPaidIcon } from '../images/voucherOriginIcons/mb-origin-paid.svg';
import { ReactComponent as OriginStaffIcon } from '../images/voucherOriginIcons/mb-origin-staff.svg';
import { ReactComponent as OriginConvertedIcon } from '../images/voucherOriginIcons/mb-origin-converted.svg';
import './VoucherOriginIcons.scss';
import { customerFacingPriceFormatter } from '../utils/utils';

export const getVoucherPaymentStatusTextOrIcon = (status: VoucherPaymentStatus, translations: any) => {
  const originLabel = translations(`vouchers.payment_status.${status}`);
  switch (status) {
    case VoucherPaymentStatus.PENDING_PAYMENT:
      return originLabel;
    case VoucherPaymentStatus.PAID:
      return (
        <Tooltip title={originLabel} arrow>
          <span className="mb-origin-paid" style={{ display: 'inline-flex' }}>
            <OriginPaidIcon width={24} height={24} aria-label={originLabel} />
          </span>
        </Tooltip>
      );
    case VoucherPaymentStatus.MANUAL:
    case VoucherPaymentStatus.CONFIRMED:
      return (
        <Tooltip title={originLabel} arrow>
          <span style={{ display: 'inline-flex' }}>
            <OriginStaffIcon width={24} height={24} aria-label={originLabel} />
          </span>
        </Tooltip>
      );
    case VoucherPaymentStatus.CONVERTED_FROM_ORDER:
      return (
        <Tooltip title={originLabel} arrow>
          <span style={{ display: 'inline-flex' }}>
            <OriginConvertedIcon width={24} height={24} aria-label={originLabel} />
          </span>
        </Tooltip>
      );
    default:
      return '';
  }
};

export const getVoucherStatus = (voucher: VoucherOut, account: AccountData, translations: any) => {
  const statusLabel = translations(`vouchers.voucherstatus.${voucher.status}`);
  switch (voucher.status) {
    case VoucherStatus.ACTIVE: {
      if (voucher.type !== VoucherType.MONETARY) {
        return (
          <Tooltip title={statusLabel} arrow>
            <span style={{ display: 'inline-flex' }}>
              <ActiveStatusIcon width={24} height={24} aria-label={statusLabel} />
            </span>
          </Tooltip>
        );
      }
      const balanceLabel = translations('vouchers.voucherstatus.activeWithBalance', {
        balance: customerFacingPriceFormatter(voucher.balance ?? 0, account),
        amount: customerFacingPriceFormatter(voucher.price, account),
      });
      return (
        <Tooltip title={balanceLabel} arrow>
          <span style={{ display: 'inline-flex' }}>
            <BalanceStatusIcon remaining={voucher.balance ?? 0} total={voucher.price} title={balanceLabel} />
          </span>
        </Tooltip>
      );
    }
    case VoucherStatus.USED:
      return (
        <Tooltip title={statusLabel} arrow>
          <span style={{ display: 'inline-flex' }}>
            <UsedStatusIcon width={24} height={24} aria-label={statusLabel} />
          </span>
        </Tooltip>
      );
    case VoucherStatus.ARCHIVED:
      return (
        <Tooltip title={statusLabel} arrow>
          <span style={{ display: 'inline-flex' }}>
            <ArchivedStatusIcon width={24} height={24} aria-label={statusLabel} />
          </span>
        </Tooltip>
      );
    case VoucherStatus.PENDING_PAYMENT:
      return (
        <Tooltip title={statusLabel} arrow>
          <span style={{ display: 'inline-flex' }}>
            <PendingPaymentStatusIcon width={24} height={24} aria-label={statusLabel} />
          </span>
        </Tooltip>
      );
    default:
      return null;
  }
};
